module.exports = "/_next/static/images/ae39469ebfdf54187a5c04d73ec2a3b4-nubank-outdoor-md@1x.jpg";